import { Store } from '../../../types';
import { getLangVar } from '../../../util/misc';

export default function StoreCard({ store }: { store: Store }) {
    const address = getLangVar(store, 'address') || '';
    const phone = getLangVar(store, 'phone') || '';
    const email = getLangVar(store, 'email') || '';
    const workHours = getLangVar(store, 'workHours') || '';
    return (
        <div className="partners-item map-popup-desc">
            <h4 className="partners-item__title map-popup-cap">{getLangVar(store, 'name')}</h4>
            <div className="partners-item__contacts">
                {address && (
                    <div className="partners-item-contact map-popup-text">
                        <div className="partners-item-contact__icon">
                            <i className="fas fa-map-marker-alt" />
                        </div>
                        <div className="partners-item-contact__text">{address}</div>
                    </div>
                )}
                {store.address && !address && (
                    <div className="partners-item-contact map-popup-text">
                        <div className="partners-item-contact__icon">
                            <i className="fas fa-map-marker-alt" />
                        </div>
                        <div className="partners-item-contact__text">{store.address}</div>
                    </div>
                )}
                {workHours && (
                    <div className="partners-item-contact map-popup-text">
                        <div className="partners-item-contact__icon">
                            <i className="fas fa-clock" />
                        </div>
                        <div className="partners-item-contact__text">{workHours}</div>
                    </div>
                )}
                {phone && (
                    <div className="partners-item-contact map-popup-text">
                        <div className="partners-item-contact__icon">
                            <i className="fas fa-phone" />
                        </div>
                        <div className="partners-item-contact__text">
                            <a href={`tel:${phone}`}>{phone}</a>
                        </div>
                    </div>
                )}
                {store.url && (
                    <a
                        href={store.url}
                        target="_blank"
                        className="partners-item-contact map-popup-text"
                        rel="noreferrer"
                    >
                        <div className="partners-item-contact__icon">
                            <i className="fas fa-mouse-pointer" />
                        </div>
                        <div className="partners-item-contact__text">{store.url}</div>
                    </a>
                )}
                {email && (
                    <a href={`mailto:${email}`} className="partners-item-contact map-popup-text">
                        <div className="partners-item-contact__icon">
                            <i className="fas fa-envelope" />
                        </div>
                        <div className="partners-item-contact__text">{email}</div>
                    </a>
                )}
                {store.product && store.product.stock && (
                    <>
                        <div className="partners-item-contact map-popup-text">
                            <div className="partners-item-contact__label">В наличии:</div>
                            <div className="partners-item-contact__text">{store.product.stock ? 'да' : 'нет'}</div>
                        </div>
                        <div className="partners-item-contact map-popup-text">
                            <div className="partners-item-contact__label">Дней доставки:</div>
                            <div className="partners-item-contact__text">{store.product.deliveryDays}</div>
                        </div>
                        {store.product.comment && (
                            <div className="partners-item-contact map-popup-text">
                                <div className="partners-item-contact__label">Примечание о доставке:</div>
                                <div className="partners-item-contact__text">{store.product.comment}</div>
                            </div>
                        )}
                    </>
                )}
            </div>
            {store.featuresByCode['ShopFair'] && (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                    href="http://honestposition.ru/"
                    target="_blank"
                    className="partners-item__image"
                    style={{
                        display: 'block',
                        textDecoration: 'none',
                        float: 'right',
                        background: 'url(/images/Hartiya.png) no-repeat',
                        width: '130px',
                        height: '40px',
                        position: 'relative',
                        top: '-3px',
                    }}
                    rel="noreferrer"
                />
            )}
        </div>
    );
}
